import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    selector: '[filedrop]'
})
export class FileDropDirective {
    @Output() files: EventEmitter<FileList> = new EventEmitter();
    @HostBinding('class') classes = '';

    constructor() {
    }

    @HostListener('dragover', ['$event'])
    public onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.classes = 'filedrop';
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.classes = '';
    }

    @HostListener('drop', ['$event'])
    public onDrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.classes = '';
        if (evt.dataTransfer.files.length > 0) {
            this.files.emit(evt.dataTransfer.files);
        }
    }
}
